import { useCallback, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { InputControl } from "components/organism";
import { ProgressBar } from "components/molecules";
import { Button } from "components/atoms";
import { useOnBoardingGs1 } from "partner/_hooks";

const prefix = "vv-account-user-email";

const UserEmail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { logoutAuth0 } = useOnBoardingGs1();
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      email: state?.email
    }
  });
  const { lookAndFeel } = useOnBoardingGs1();
  const { partner } = useParams();
  const initialized = useRef();

  const onSubmit = () => navigate(`/partner/${partner}/userData`, { state });

  const checkIt = useCallback(() => {
    if (!state?.token|| !state?.email || !state?._id) {
      logoutAuth0(partner);
      navigate(`/partner/${partner}/auth0`);
    }
  }, [state, partner, logoutAuth0, navigate]);

  useEffect(() => {
    if (!initialized?.current) {
      initialized.current = true;
      checkIt();
    }
  }, [checkIt])

  return (
    <div className={prefix}>
      <div className="mb-5">
        <ProgressBar 
          progress={1} max={5} 
          color={lookAndFeel?.progressbar}
        />
      </div>
      <div className="flex flex-wrap flex-col gap-5">
        <p className="text-center text-3xl font-bold mx-auto pb-5">Correo electrónico</p>

        <form 
          className="flex flex-wrap flex-col gap-10"
          onSubmit={handleSubmit(onSubmit)}
        >
          <InputControl
            errors={errors?.email}
            label="Correo electrónico"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              readOnly: true,
              ...register("email")}
            }
          />

          <Button
            className="text-white rounded-lg"
            style={{
              backgroundColor: lookAndFeel?.primary?.solid,
              color: lookAndFeel?.primary?.text
            }}
            fullwidth
            pulse
            type="submit"
          >Continuar</Button>
        </form>
      </div>
    </div>
  )
};

export default UserEmail;
